/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputAdminOTGPolygonPoint } from './InputAdminOTGPolygonPoint';
import {
    InputAdminOTGPolygonPointFromJSON,
    InputAdminOTGPolygonPointFromJSONTyped,
    InputAdminOTGPolygonPointToJSON,
} from './InputAdminOTGPolygonPoint';

/**
 * 
 * @export
 * @interface InputAdminOTGPolygon
 */
export interface InputAdminOTGPolygon {
    /**
     * 
     * @type {Array<InputAdminOTGPolygonPoint>}
     * @memberof InputAdminOTGPolygon
     */
    points: Array<InputAdminOTGPolygonPoint>;
}

/**
 * Check if a given object implements the InputAdminOTGPolygon interface.
 */
export function instanceOfInputAdminOTGPolygon(value: object): boolean {
    if (!('points' in value)) return false;
    return true;
}

export function InputAdminOTGPolygonFromJSON(json: any): InputAdminOTGPolygon {
    return InputAdminOTGPolygonFromJSONTyped(json, false);
}

export function InputAdminOTGPolygonFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminOTGPolygon {
    if (json == null) {
        return json;
    }
    return {
        
        'points': ((json['points'] as Array<any>).map(InputAdminOTGPolygonPointFromJSON)),
    };
}

export function InputAdminOTGPolygonToJSON(value?: InputAdminOTGPolygon | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'points': ((value['points'] as Array<any>).map(InputAdminOTGPolygonPointToJSON)),
    };
}

